import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";

export default function SuccessAlert({isOpen, message}) {
    return (
        <Snackbar open={isOpen}>
            <Alert severity="success">
                {message}
            </Alert>
        </Snackbar>
    )
}